<template>
  <Card>
    <el-row :gutter="10">
      <el-col :xs="24" :sm="24" :md="24" :lg="6" :xl="6" class="container-prod-name">
        <div class="grid-content bg-purple prod-name"
          :class="{ 'prod-name-priority': product.priority}">
          <span data-test="name" class="name-product"
            :class="{ 'name-product-priority': product.priority || product.highlightName,
             'name-product-highlight': product.highlightName}">
            <!-- <el-tooltip class="item"
              effect="dark"
              content="Ce produit doit être saisi."
              placement="right">
              <i class="el-icon-star-on icon-can-be-empty"
              v-if="product.canBeEmpty === false"></i>
            </el-tooltip> -->
            {{ product.nameDisplayed }}
          </span>
          <span data-test="unit" class="unit-product"
          :class="{ 'unit-product-highlight': product.highlightPackaging}">
            ({{ product.unit }})
          </span>
          <i v-if="product.highlightPackaging === true
          || product.highlightName === true"
          class="el-icon-warning warning-highlight"></i>
          <span v-if="product.average !== null"
            data-test="average" class="average-product">
          Moyenne nationale : {{ product.average }}
          </span>

        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="18" :xl="18" class="container-prod-quantities">
        <div class="grid-content bg-purple-light prod-quantities" data-test="prod-quantity">
          <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8" class="input-line"
          v-if="product.displayAreaSelling">
            <el-badge :value="'avant'" class="item" type="primary">
              <el-tooltip class="item"
                :content="displayTooltipInput"
                effect="dark"
                placement="top">
                <el-input-number v-model="quantityAreaSelling"
                @change="inputQuantityAreaSelling"
                data-test="prod-qty-sel"
                data-v-step="prod-qty-av"
                size="small"
                :min="0"></el-input-number>
                <!-- :step="1"
                :step-strictly="product.isInteger" -->
              </el-tooltip>
            </el-badge>
          </el-col>
          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" class="input-line"  data-v-step="2">
            <el-badge :value="'arrière'" class="item" type="primary">
              <el-tooltip class="item"
                :content="displayTooltipInput"
                effect="dark"
                placement="top">
                <el-input-number v-model="quantityAreaStock"
                @change="inputQuantityAreaStock"
                data-v-step="prod-qty-ar"
                data-test="prod-qty-sto"
                size="small"
                :min="0"></el-input-number>
                <!-- :step="1"
                :step-strictly="product.isInteger" -->
              </el-tooltip>
            </el-badge>
          </el-col>
          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8"  data-v-step="total">
          <!-- <el-badge value="Total" class="item" type="primary"> -->
          <span class="total-qty-product">  Total : {{ displayTotal }} </span>
          <!-- </el-badge> -->
            <el-alert
              v-if="product.recommandation !== ''"
              :title="product.recommandation"
              type="info"
              style="margin-bottom: 5px;"
              :closable="false"
              show-icon>
            </el-alert>
            <el-alert
             v-if="displayQuantityWarning !== ''"
             type="warning"
             :closable="false"
             show-icon>
             <!-- :title="displayQuantityWarning" -->
             <div v-html="displayQuantityWarning">
             <!-- {{ displayQuantityWarning }} -->
            </div>
           </el-alert>
            <!-- <span data-test="unit" class="unit-product">
            {{ product.unit }}{{ unitPluriel }}</span> -->
          </el-col>

        </div>
      </el-col>
    </el-row>
  </Card>
</template>

<script>
import Card from '@/components/Card/Card.vue';
// import _ from 'lodash';

export default {
  components: {
    // Inventory,
    Card,
  },
  props: {
    product: { type: Object },
    productsAverageQty: { type: Number, default: 33 },
    valeurAnormale: { type: Boolean, default: false },
    // productName: { type: String },
    // productQuantity: { type: Number, default: undefined },
  },
  data() {
    return {
      quantityAreaSelling: null,
      quantityAreaStock: null,
    };
  },
  mounted() {
    this.quantityAreaSelling = this.product.quantityAreaSelling;
    this.quantityAreaStock = this.product.quantityAreaStock;
    // this.reception = this.product.reception;
    // this.quantity = this.productQuantity;
  },
  methods: {
    inputQuantityAreaStock() {
    // inputQuantityAreaStock(currentValue, oldValue) {
      const { quantityAreaStock, quantityAreaSelling, ...productRest } = this.product;
      // if (this.quantityAreaStock === undefined) {
      //   // this.quantityAreaStock = oldValue;
      //   this.quantityAreaStock = undefined;
      // }
      if (this.product.isInteger === true && this.quantityAreaStock !== undefined
         && this.quantityAreaStock !== null && !Number.isNaN(this.quantityAreaStock)) {
        // console.log(Math.floor(this.quantityAreaStock));
        this.quantityAreaStock = Math.floor(this.quantityAreaStock);
        // console.log(this.quantityAreaStock);
      }
      if (this.product.isInteger === false && this.quantityAreaStock !== undefined
        && this.quantityAreaStock !== null && !Number.isNaN(this.quantityAreaStock)) {
        // console.log(Math.floor(this.quantityAreaStock));
        this.quantityAreaStock = this.quantityAreaStock.toFixed(2);
      }
      const newQuantityAreaStock = this.quantityAreaStock === undefined
        ? null : this.quantityAreaStock;
      const data = {
        ...productRest,
        // quantityAreaStock: this.quantityAreaStock,
        quantityAreaStock: newQuantityAreaStock,
      };
      this.$emit('onInput', data);
      // this.$emit('onInput');
    },
    inputQuantityAreaSelling() {
      const { quantityAreaStock, quantityAreaSelling, ...productRest } = this.product;
      // if (this.quantityAreaSelling === undefined) {
      //   // Promise.reject();
      //   this.quantityAreaSelling = null;
      // }
      if (this.product.isInteger === true && this.quantityAreaSelling !== undefined
        && this.quantityAreaSelling !== null && !Number.isNaN(this.quantityAreaSelling)) {
        this.quantityAreaSelling = Math.floor(this.quantityAreaSelling);
      }
      if (this.product.isInteger === false && this.quantityAreaSelling !== undefined
        && this.quantityAreaSelling !== null && !Number.isNaN(this.quantityAreaSelling)) {
        this.quantityAreaSelling = this.quantityAreaSelling.toFixed(2);
      }
      const newQuantityAreaSelling = this.quantityAreaSelling === undefined
        ? null : this.quantityAreaSelling;
      const data = {
        // ...this.product,
        ...productRest,
        // quantityAreaSelling: this.quantityAreaSelling,
        quantityAreaSelling: newQuantityAreaSelling,
      };
      this.$emit('onInput', data);
      // this.$emit('onInput');
    },
  },
  computed: {
    displayTooltipInput() {
      if (this.product.isInteger === false) {
        return "Nombre décimal accepté (mettre un point au lieu d'une virgule, ex : 12.5)";
      }
      return 'Nombre entier attendu';
    },
    displayTotal() {
      if (this.quantityAreaSelling === undefined && this.quantityAreaStock === undefined) {
        return 'Non connu.';
      }
      if (this.quantityAreaSelling !== undefined && this.quantityAreaStock === undefined) {
        return this.quantityAreaSelling;
      }
      if (this.quantityAreaSelling === undefined && this.quantityAreaStock !== undefined) {
        return this.quantityAreaStock;
      }
      const total = this.quantityAreaSelling + this.quantityAreaStock;
      // si c'est un float
      // console.log('displayTotal !!!!!!!');
      console.log(total);
      if (Number(total) === total && total % 1 !== 0) {
        // console.log('to fixed !!!!!!!');
        return total.toFixed(2);
      }
      return total;
    },
    displayQuantityWarning() {
      // return '';
      /* eslint-disable */
      /*
      const total = this.quantityAreaSelling + this.quantityAreaStock;
      const { quantityMax, quantityMin } = this.product;
      if(quantityMin !== null && quantityMax !== null){
        if (!Number.isNaN(total)
          && !_.inRange(total, parseFloat(quantityMin), parseFloat(quantityMax))) {
          return 'Valeur anormale';
        }
      }
      */
      // console.log('displayQuantityWarning');
      // console.log(this.quantityAreaSelling);
      // console.log(this.displayAreaSelling);
      if (this.valeurAnormale || this.quantityAreaStock === undefined
        || (this.quantityAreaSelling === undefined
          && this.product.displayAreaSelling === true)){
        const { quantityMax, quantityMin, unit } = this.product;
        if (quantityMax === null && quantityMin === null) {
          return 'Valeur anormale.';
        }
        let textEgal =  `compris entre ${quantityMin} et ${quantityMax}`;
        if (quantityMax === quantityMin) {
          textEgal =  `égal à ${quantityMax}`;
        }
        return `Valeur anormale. <br/>Le total devrait être ${textEgal} (${unit})`;
      }
      return '';
      /* eslint-enable */
    },
  },
};
</script>
<style>
/*
@media (min-width: 1600px){
  #list-products .el-alert {
    display: inline;
  }
}
*/
.el-badge__content.is-fixed {
    top: 50%;
    right: -5px;
    font-size: 17px;
    border-radius: 0;
    padding: 5px;
    border: none;
}
.icon-can-be-empty {
  font-size: 22px;
  color: #409EFF;
}
.bg-purple {
  text-align: left !important;
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
h3
  margin 40px 0 0

ul
  list-style-type none
  padding 0

li
  display inline-block
  margin 0 10px

a
  color #42b983

.name-product
  margin: 10px;
  display: inline-block;

.name-product-priority
  border-bottom: 2px solid;
  font-size: 15px;
  display: inline;

.unit-product
  /* margin: 10px; */
  font-weight: bold;
  font-size: 15px;

.total-qty-product
  margin: 10px;

.container-product
  display: flex;
  flex-direction: row;

.container-prod-quantities, .container-prod-name {
  display: flex;
}

.prod-quantities, .prod-name
  width: 100%;

.prod-name-priority
  border: 3px solid #E6A23C;

.unit-product-highlight, .name-product-highlight
  color: #67C23A;
  border-bottom: 2px solid;

.warning-highlight
  font-size: 25px;
  margin-left: 10px;
  color: #F56C6C;

.average-product
  display: block;
  font-size: 12px;
  margin-left: 10px;

.el-badge__content.is-fixed
  top: -6px;
  right: 80px;
  z-index: 1000 !important;

/* .name-product
  width: 150px; */

.el-col
  border-radius: 4px;

.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
  text-align: right;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 40px;
  padding: 15px;
}

@media (max-width: 1199px){
  .bg-purple {
    text-align: left;
  }
  .input-line {
    margin-bottom: 18px;
  }
}

.el-badge__content
  z-index: 10;
</style>
